import React, { useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
//import { BookList } from '../../enums';
import book_1 from './book.pdf'
import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `./pdf.worker.js`;

const FullScreenModal = ((props) => {

    const {
        show,
        setPageNumber,
        handleChangePage,
        numPages,
        pageNumber,
        setControlPageNumber,
        handleGoToPage,
        handleToggleDocFullScreen,
        controlPageNumber,
        initialize,
        selectedBook,
        handleLoadSuccess
    } = props

    //const [height, setHeight] = React.useState(0)
    const [width, setWidth] = React.useState(0)

    useEffect(() => {
        //setHeight(window.innerHeight)
        setWidth(Math.round(window.innerWidth * 0.81))
    }, [])


    return (
        <Modal show={show} onHide={handleToggleDocFullScreen} animation={true} size={'xl'} style={{ width: 100 + '%', left: 10 + '%' }}>
            <Modal.Body style={{ padding: 0, width: 'fit-content' }}>
                {/* <div ref={ref && ref.current} /> */}
                <div className="pdf-controls" style={{ textAlign: 'center' }}>
                    <Button
                        onClick={() => setPageNumber(1)}
                        variant="warning"
                        disabled={pageNumber === 1}
                        className="pdf-control-button first-page" />
                    <Button
                        onClick={handleChangePage(-1)}
                        variant="warning"
                        disabled={pageNumber <= 1}
                        className="pdf-control-button previous-page" />
                    <Button
                        disabled={pageNumber >= numPages}
                        onClick={handleChangePage(1)}
                        variant="warning"
                        className="pdf-control-button next-page"
                    />
                    <Button
                        disabled={pageNumber === numPages}
                        onClick={() => setPageNumber(numPages)}
                        variant="warning"
                        className="pdf-control-button last-page"
                    />
                    <input
                        className="current-page"

                        onFocus={(e) => e.target.select()}
                        onChange={(e) => setControlPageNumber(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleGoToPage(controlPageNumber)}
                        type="text"
                        value={controlPageNumber} />
                    <input className="total-pages" disabled type="text" value={numPages ? `/ ${numPages}` : '-'} />
                    <Button
                        onClick={handleToggleDocFullScreen}
                        variant="warning"
                        className="pdf-control-button fullscreen-page"
                    />
                </div>
                <div className="pdf-document">
                    <Document
                        file={book_1}
                        onLoadSuccess={handleLoadSuccess}
                        className='no-select'
                    >
                        <Page
                            // height={height - 150}
                            // scale={1}
                            width={width}
                            className='my-page'
                            pageNumber={pageNumber}
                            //inputRef={(ref) => { docRef.current = ref; console.log(ref) }}
                            onRenderSuccess={initialize}
                            renderMode={'svg'}
                        />
                    </Document>
                </div>


            </Modal.Body>

        </Modal>
    )
})
export default FullScreenModal